import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Forum (All)',
  basePath: '/forum-all',
  columns: [
    { key: 'forum_date', label: 'Date', sortable: true },
    { key: 'forum_name', label: 'Name', sortable: true },
    { key: 'forum_email', label: 'Email', sortable: true },
    { key: 'forum_text', label: 'Text', sortable: true },
    { key: 'forumtemat_name', label: 'Theme', sortable: true },
  ],
  fields: [
    { key: 'forum_name', label: 'Name', type: 'text', required: true },
    { key: 'forum_email', label: 'Email', type: 'text' },
    { key: 'forum_text', label: 'Text', type: 'textarea' },
    { key: 'forum_date', label: 'Date', type: 'datetime' },
    { key: 'forumtemat_id', label: 'Theme', type: 'async-select',
      optionsUrl: '/forum-themes/options',
      placeholder: 'Select theme' },
  ],
  filters: [
    { key: 'theme', label: 'Theme', type: 'select',
      optionsUrl: '/forum-themes/options' },
  ],
  defaultSort: { field: 'forum_date', dir: 'desc' },
});
